/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FlairFactory, FlairFactoryInterface } from "../FlairFactory";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "deployer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "proxyAddress",
        type: "address",
      },
    ],
    name: "ProxyCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "WithdrawPowerRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "claimTokens",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "cloneDeterministicSimple",
    outputs: [
      {
        internalType: "address",
        name: "deployedProxy",
        type: "address",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockWithdrawMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockWithdrawRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "predictDeterministicSimple",
    outputs: [
      {
        internalType: "address",
        name: "deployedProxy",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revokeWithdrawPower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum WithdrawMode",
        name: "_withdrawMode",
        type: "uint8",
      },
    ],
    name: "setWithdrawMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_withdrawRecipient",
        type: "address",
      },
    ],
    name: "setWithdrawRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "claimTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawMode",
    outputs: [
      {
        internalType: "enum WithdrawMode",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawModeLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawPowerRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawRecipientLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FlairFactory__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FlairFactory> {
    return super.deploy(overrides || {}) as Promise<FlairFactory>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FlairFactory {
    return super.attach(address) as FlairFactory;
  }
  connect(signer: Signer): FlairFactory__factory {
    return super.connect(signer) as FlairFactory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FlairFactoryInterface {
    return new utils.Interface(_abi) as FlairFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FlairFactory {
    return new Contract(address, _abi, signerOrProvider) as FlairFactory;
  }
}
